export interface BiometricsResult {
  height: number;
  weight: number;
}

export const convertBiometrics = (
  feet: number | null,
  inches: number | null,
  weightLbs: number | null
): BiometricsResult => {
  const ftToCm = (feet || 0) * 30.48;
  const inToCm = (inches || 0) * 2.54;

  return {
    height: ftToCm + inToCm,
    weight: (weightLbs || 0) * 0.453592,
  };
};
